import Unistring from 'unistring';

// eslint-disable-next-line import/prefer-default-export
export const ALLOWED_TYPES_OF_WORDS = [
  Unistring.WBP.ALetter,
  Unistring.WBP.Numeric,
  Unistring.WBP.ExtendNumLet,
];
